/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MessageKind } from './message-kind';
import {
    MessageKindFromJSON,
    MessageKindFromJSONTyped,
    MessageKindToJSON,
    MessageKindToJSONTyped,
} from './message-kind';
import type { AssetResponse } from './asset-response';
import {
    AssetResponseFromJSON,
    AssetResponseFromJSONTyped,
    AssetResponseToJSON,
    AssetResponseToJSONTyped,
} from './asset-response';
import type { Location } from './location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './location';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * Unique identifier for a message.
     * @type {string}
     * @memberof Message
     */
    id: string;
    /**
     * Unique identifier for the tenant.
     * @type {string}
     * @memberof Message
     */
    tenantId: string;
    /**
     * Timestamp when the conversation was created.
     * @type {Date}
     * @memberof Message
     */
    createdAt: Date;
    /**
     * Timestamp when the conversation was last updated. Initially the same as created_at.
     * @type {Date}
     * @memberof Message
     */
    updatedAt: Date;
    /**
     * Unique identifier for a conversation type.
     * @type {string}
     * @memberof Message
     */
    conversationId: string;
    /**
     * The id of the participant this messages is posted by.
     * @type {string}
     * @memberof Message
     */
    participantId: string;
    /**
     * The sequence of the message in the conversation. This will be null if the message has not been processed yet.
     * @type {number}
     * @memberof Message
     */
    sequence: number | null;
    /**
     * The kind of message.
     * @type {MessageKind}
     * @memberof Message
     */
    kind: MessageKind;
    /**
     * The text of the message. If kind is TEXT or REQUEST_LOCATION, this field is required.
     * @type {string}
     * @memberof Message
     */
    text?: string | null;
    /**
     * 
     * @type {Location}
     * @memberof Message
     */
    location?: Location | null;
    /**
     * The formatted address of the location.
     * @type {string}
     * @memberof Message
     */
    formattedAddress?: string | null;
    /**
     * 
     * @type {AssetResponse}
     * @memberof Message
     */
    asset?: AssetResponse | null;
    /**
     * Source id of the message.
     * @type {string}
     * @memberof Message
     */
    sourceId?: string | null;
    /**
     * Timestamp when the message was deleted.
     * @type {Date}
     * @memberof Message
     */
    deletedAt?: Date | null;
}



/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): value is Message {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('participantId' in value) || value['participantId'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tenantId': json['tenant_id'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
        'conversationId': json['conversation_id'],
        'participantId': json['participant_id'],
        'sequence': json['sequence'],
        'kind': MessageKindFromJSON(json['kind']),
        'text': json['text'] == null ? undefined : json['text'],
        'location': json['location'] == null ? undefined : LocationFromJSON(json['location']),
        'formattedAddress': json['formatted_address'] == null ? undefined : json['formatted_address'],
        'asset': json['asset'] == null ? undefined : AssetResponseFromJSON(json['asset']),
        'sourceId': json['source_id'] == null ? undefined : json['source_id'],
        'deletedAt': json['deleted_at'] == null ? undefined : (new Date(json['deleted_at'])),
    };
}

export function MessageToJSON(json: any): Message {
    return MessageToJSONTyped(json, false);
}

export function MessageToJSONTyped(value?: Message | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenant_id': value['tenantId'],
        'created_at': ((value['createdAt']).toISOString()),
        'updated_at': ((value['updatedAt']).toISOString()),
        'conversation_id': value['conversationId'],
        'participant_id': value['participantId'],
        'sequence': value['sequence'],
        'kind': MessageKindToJSON(value['kind']),
        'text': value['text'],
        'location': LocationToJSON(value['location']),
        'formatted_address': value['formattedAddress'],
        'asset': AssetResponseToJSON(value['asset']),
        'source_id': value['sourceId'],
        'deleted_at': value['deletedAt'] == null ? undefined : ((value['deletedAt'] as any).toISOString()),
    };
}

